'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  return function (number) {
    if (/^\d{8}$/.test(number)) {
      return '';
    }
    return (0, _getErrorMessage2.default)('Bank account number must be 8 digits in length', {
      value: number
    });
  };
};